// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/group_class_attendance/v1/group_class_attendance.proto (package fingertip.creator.group_class_attendance.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { AcceptWaitlistedRequest, AcceptWaitlistedResponse, CancelGroupClassAttendancePublicRequest, CancelGroupClassAttendancePublicResponse, CancelGroupClassAttendanceRequest, CancelGroupClassAttendanceResponse, CompleteGroupClassAttendanceRequest, CompleteGroupClassAttendanceResponse, ConfirmAttendanceRequestPublicRequest, ConfirmAttendanceRequestPublicResponse, DeleteGroupClassAttendanceRequest, DeleteGroupClassAttendanceResponse, GetAttendancePaymentDetailsPublicRequest, GetAttendancePaymentDetailsPublicResponse, GetGroupClassAttendancePublicRequest, GetGroupClassAttendancePublicResponse, GetGroupClassAttendanceRequest, GetGroupClassAttendanceResponse, GetWaitlistItemsRequest, GetWaitlistItemsResponse, RejectWaitlistedRequest, RejectWaitlistedResponse, UpdateGroupClassAttendanceRequest, UpdateGroupClassAttendanceResponse } from "./group_class_attendance_pb.js";

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.UpdateGroupClassAttendance
 */
export const updateGroupClassAttendance = {
  localName: "updateGroupClassAttendance",
  name: "UpdateGroupClassAttendance",
  kind: MethodKind.Unary,
  I: UpdateGroupClassAttendanceRequest,
  O: UpdateGroupClassAttendanceResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.DeleteGroupClassAttendance
 */
export const deleteGroupClassAttendance = {
  localName: "deleteGroupClassAttendance",
  name: "DeleteGroupClassAttendance",
  kind: MethodKind.Unary,
  I: DeleteGroupClassAttendanceRequest,
  O: DeleteGroupClassAttendanceResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.GetGroupClassAttendance
 */
export const getGroupClassAttendance = {
  localName: "getGroupClassAttendance",
  name: "GetGroupClassAttendance",
  kind: MethodKind.Unary,
  I: GetGroupClassAttendanceRequest,
  O: GetGroupClassAttendanceResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.GetGroupClassAttendancePublic
 */
export const getGroupClassAttendancePublic = {
  localName: "getGroupClassAttendancePublic",
  name: "GetGroupClassAttendancePublic",
  kind: MethodKind.Unary,
  I: GetGroupClassAttendancePublicRequest,
  O: GetGroupClassAttendancePublicResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.GetAttendancePaymentDetailsPublic
 */
export const getAttendancePaymentDetailsPublic = {
  localName: "getAttendancePaymentDetailsPublic",
  name: "GetAttendancePaymentDetailsPublic",
  kind: MethodKind.Unary,
  I: GetAttendancePaymentDetailsPublicRequest,
  O: GetAttendancePaymentDetailsPublicResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.CompleteGroupClassAttendance
 */
export const completeGroupClassAttendance = {
  localName: "completeGroupClassAttendance",
  name: "CompleteGroupClassAttendance",
  kind: MethodKind.Unary,
  I: CompleteGroupClassAttendanceRequest,
  O: CompleteGroupClassAttendanceResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.CancelGroupClassAttendance
 */
export const cancelGroupClassAttendance = {
  localName: "cancelGroupClassAttendance",
  name: "CancelGroupClassAttendance",
  kind: MethodKind.Unary,
  I: CancelGroupClassAttendanceRequest,
  O: CancelGroupClassAttendanceResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.CancelGroupClassAttendancePublic
 */
export const cancelGroupClassAttendancePublic = {
  localName: "cancelGroupClassAttendancePublic",
  name: "CancelGroupClassAttendancePublic",
  kind: MethodKind.Unary,
  I: CancelGroupClassAttendancePublicRequest,
  O: CancelGroupClassAttendancePublicResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.AcceptWaitlisted
 */
export const acceptWaitlisted = {
  localName: "acceptWaitlisted",
  name: "AcceptWaitlisted",
  kind: MethodKind.Unary,
  I: AcceptWaitlistedRequest,
  O: AcceptWaitlistedResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.RejectWaitlisted
 */
export const rejectWaitlisted = {
  localName: "rejectWaitlisted",
  name: "RejectWaitlisted",
  kind: MethodKind.Unary,
  I: RejectWaitlistedRequest,
  O: RejectWaitlistedResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.GetWaitlistItems
 */
export const getWaitlistItems = {
  localName: "getWaitlistItems",
  name: "GetWaitlistItems",
  kind: MethodKind.Unary,
  I: GetWaitlistItemsRequest,
  O: GetWaitlistItemsResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService.ConfirmAttendanceRequestPublic
 */
export const confirmAttendanceRequestPublic = {
  localName: "confirmAttendanceRequestPublic",
  name: "ConfirmAttendanceRequestPublic",
  kind: MethodKind.Unary,
  I: ConfirmAttendanceRequestPublicRequest,
  O: ConfirmAttendanceRequestPublicResponse,
  service: {
    typeName: "fingertip.creator.group_class_attendance.v1.GroupClassAttendanceService"
  }
};
